import styled from "styled-components"
import {Col} from "react-bootstrap"

export const StyledCol = styled(Col)`
  margin-bottom: 10px;
`

export const StyledLabel = styled.label`
  display: inline;
  margin-left: ${({theme}) => theme.spacing.oneAndHalf};
`

export const CheckboxInput = styled.input`
  opacity: 0;
`
// As we have styled our own Checkbox this outline is used to replace the Checkbox when it is ticked
export interface CheckboxOutlineProps {
  disabled?: boolean
}
export const CheckboxOutline = styled.label<CheckboxOutlineProps>`
  width: 16px;
  height: 16px;
  cursor: ${({disabled}) => (disabled ? "not-allowed" : "pointer")};
  position: absolute;
  top: 4px;
  left: 0;
  /* Temporary Check to avoid JEST test failure */
  background-color: ${({theme}) => theme.colors.utility.white};
  border: 1px solid black;
  border-radius: 3px;
`

export const CheckboxUI = styled.div`
  width: 16px;
  display: inline-block;
  position: relative;
  ${CheckboxInput}:checked + ${CheckboxOutline} {
    /* Temporary Check to avoid JEST test failure */
    background-color: ${({theme}) => theme.colors.primary1};
    border: 1px solid ${({theme}) => theme.colors.primary1};
    &:after {
      opacity: 1;
      content: "";
      width: 10px;
      height: 6px;
      position: absolute;
      top: 3px;
      left: 2px;
      /* Temporary Check to avoid JEST test failure */
      border: 2px solid ${({theme}) => theme.colors.utility.white};
      border-top: none;
      border-right: none;
      background: transparent;
      transform: rotate(-45deg);
    }
  }
`
